// Safari-specific utilities
export const isSafari = (): boolean => {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.includes('safari') && !userAgent.includes('chrome');
};

export const getSafariFetchOptions = (): RequestInit => {
  return {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      // Safari-specific headers to prevent caching issues
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0'
    },
    // Safari-specific fetch options
    mode: 'cors',
    credentials: 'same-origin'
  };
};

export const handleSafariError = (error: any): boolean => {
  return isSafari() || error instanceof TypeError;
};

// Safari-specific cookie clearing
export const clearSafariCookies = (): void => {
  if (isSafari()) {
    // Clear all cookies to prevent Safari caching issues
    document.cookie.split(";").forEach(function(c) { 
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
    });
    
    // Clear localStorage and sessionStorage
    localStorage.clear();
    sessionStorage.clear();
  }
};

// Safari-specific logout handler
export const handleSafariLogout = async (signOut: () => Promise<any>): Promise<void> => {
  await signOut();
  
  if (isSafari()) {
    clearSafariCookies();
  }
  
  // Force a complete page reload to clear all state
  window.location.reload();
}; 